import { Injectable, Type } from '@angular/core';
import { SupportModalBlockComponent } from '@lib/components/support-class/support-modal-block-component';
import { ModalBlockParts } from '@lib/services/modal/modal-part.state.';
import { LModalContentsWidthType, ModalType } from '@lib/components/shared-ui-components/modal/modal.state';
import { SupportInformationParts } from '@common/interfaces/mybooking/modals/passenger-information-input/passenger-information.interface';
import { SpecialAssistanceRequestData } from '@common/interfaces/mybooking/modals/passenger-information-input/special-assistance-request-modal.interface';

@Injectable()
export class SpecialAssistanceRequestModalService {
  public specialAssistanceRequestData?: SpecialAssistanceRequestData;

  /**
   * サポート情報入力モーダルを開く際のパラメータ、payloadの設定は各自で行う
   * 例：
   * const part = specialAssistanceRequestModalParts;
   * this.modal.showSubModal(part);
   */
  public createSpecialAssistanceRequestModalParts(
    component: Type<SupportModalBlockComponent>,
    payLoad: SupportInformationParts
  ): ModalBlockParts {
    return {
      id: 'SpecialAssistanceRequestComponentParts',
      block: component,
      closeBackEnable: true,
      type: ModalType.TYPE7,
      modalWidth: LModalContentsWidthType.MODAL_PC_W768,
      payload: payLoad,
    };
  }
}
